import string from "./string";
import since from "./since";
import link from "./link";
import assigned from "./assigned";
import date from "./date";
import dateNoTime from "./dateNoTime";
import range from "./range";
import notifications from "./notifications";
import bool from "./bool";

export default {
  string,
  since,
  link,
  assigned,
  date,
  dateNoTime,
  range,
  notifications,
  bool,
};
